import React from 'react'
import { Admin, Resource } from 'react-admin'

// import AppsIcon from '@material-ui/icons/Apps'

import { Dashboard } from 'modules/dashboard'
import { CreateLesson, EditLesson, ListLessons } from 'modules/lessons'
import { CreateCourse, ListCourses, EditCourse } from 'modules/courses'
import { CreateTag, ListTags, EditTag } from 'modules/tags'
import { CreateWeek, ListWeeks, EditWeeks } from 'modules/weeks'
import { CreateVideo, ListVideos, EditVideo } from 'modules/video'
import { CreateImage, ListImages, EditImage } from 'modules/images'
import {
  CreateAttachment,
  ListAttachments,
  EditAttachment,
} from 'modules/attachments'
import { CreatePerson, EditPerson, ListPersons } from 'modules/persons'
import { EditBanner, ListBanners } from 'modules/banner'
import { ListPopups, CreatePopup, EditPopup } from 'modules/popups'
import {
  CreateCommentQuestion,
  ListCommentQuestions,
  EditCommentQuestion,
} from 'modules/comments-question'
import { ListUsers, CreateUser, EditUser } from 'modules/users'
import { CreateStylesheet, ListStylesheets } from 'modules/stylesheet'
import { CreateQuiz, ListQuizzes, EditQuizz } from 'modules/quizzes'
import { CreateMark, ListMarks } from 'modules/marks'
import { CreateSlider, EditSlider, ListSliders } from 'modules/slider'
import { CreateStuffLinker } from 'modules/stuff-linker'
import { CacheControl } from 'modules/cache'

import dataProvider from 'dataProviders/serviceProvider'
import authProvider from 'auth/authProvider'
import { i18nProvider } from 'i18n/i18nProvider'

import ErrorBoundary from 'components/ErrorBoundary'

import TreeMenu from '@bb-tech/ra-treemenu'

import { theme } from 'theme'

import { lessonReducer, courseReducer, popupReducer } from 'customReducers'

// ICONS
import PermMedia from '@material-ui/icons/PermMedia'
import MovieIcon from '@material-ui/icons/Movie'
import ImageIcon from '@material-ui/icons/Image'
import AttachmentIcon from '@material-ui/icons/Attachment'
import FeaturedVideoIcon from '@material-ui/icons/FeaturedVideo'
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices'
import ModeCommentIcon from '@material-ui/icons/ModeComment'
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser'
import PeopleIcon from '@material-ui/icons/People'
import TitleIcon from '@material-ui/icons/Title'
import LabelImportantIcon from '@material-ui/icons/LabelImportant'
import ColorLensIcon from '@material-ui/icons/ColorLens'
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos'
import BallotIcon from '@material-ui/icons/Ballot'
import LiveTvIcon from '@material-ui/icons/LiveTv'
import ChromeReaderModeIcon from '@material-ui/icons/ChromeReaderMode'
import SdStorage from '@material-ui/icons/SdStorage'
import Crop75Icon from '@material-ui/icons/Crop75'
import PlaylistAddCheck from '@material-ui/icons/PlaylistAddCheck'
import { ViewCarousel } from '@material-ui/icons'

const App = () => {
  return (
    <ErrorBoundary>
      <Admin
        theme={theme}
        dataProvider={dataProvider}
        authProvider={authProvider}
        dashboard={Dashboard}
        i18nProvider={i18nProvider}
        menu={TreeMenu}
        customReducers={{
          lessonModule: lessonReducer,
          courseModule: courseReducer,
          popupModule: popupReducer,
        }}
      >
        {/* Media submenu */}
        <Resource
          name="media"
          options={{ label: 'Mídias', isMenuParent: true }}
          icon={PermMedia}
        />

        <Resource
          name="cms/content/images"
          list={ListImages}
          // edit={EditImage}
          icon={ImageIcon}
          create={CreateImage}
          options={{ label: 'Imagens', menuParent: 'media' }}
        />

        <Resource
          name="cms/content/videos"
          list={ListVideos}
          // edit={EditVideo}
          create={CreateVideo}
          icon={MovieIcon}
          options={{ label: 'Videos', menuParent: 'media' }}
        />

        <Resource
          name="cms/content/attachments"
          list={ListAttachments}
          // edit={EditAttachment}
          icon={AttachmentIcon}
          create={CreateAttachment}
          options={{ label: 'Materiais (Anexos)', menuParent: 'media' }}
        />

        {/* Highlights submenu */}
        <Resource
          name="highlights"
          options={{ label: 'Destaques', isMenuParent: true }}
          icon={ImportantDevicesIcon}
        />

        <Resource
          name="cms/highlight/slider"
          list={ListSliders}
          edit={EditSlider}
          icon={ViewCarousel}
          // create={CreateSlider}
          options={{ label: 'Slider (Home)', menuParent: 'highlights' }}
        />

        <Resource
          name="cms/highlight/banner"
          list={ListBanners}
          edit={EditBanner}
          icon={FeaturedVideoIcon}
          // create={CreateBanner}
          options={{ label: 'Banners (Home)', menuParent: 'highlights' }}
        />

        {/* Content submenu */}
        <Resource
          name="content"
          options={{ label: 'Conteúdo', isMenuParent: true }}
        />

        <Resource
          name="cms/grouper/courses"
          create={CreateCourse}
          list={ListCourses}
          edit={EditCourse}
          icon={ChromeReaderModeIcon}
          options={{ label: 'Cursos/Séries', menuParent: 'content' }}
        />

        <Resource
          name="cms/grouper/week"
          create={CreateWeek}
          list={ListWeeks}
          edit={EditWeeks}
          icon={BallotIcon}
          options={{ label: 'Semanas', menuParent: 'content' }}
        />
        <Resource
          name="cms/grouper/lesson"
          list={ListLessons}
          edit={EditLesson}
          create={CreateLesson}
          options={{ label: 'Aulas', menuParent: 'content' }}
          icon={LiveTvIcon}
        />

        <Resource
          name="cms/content/involved_people"
          list={ListPersons}
          edit={EditPerson}
          create={CreatePerson}
          icon={PeopleIcon}
          options={{ label: 'Pessoas', menuParent: 'content' }}
        />

        <Resource
          name="cms/content/tags"
          list={ListTags}
          // edit={EditTag}
          create={CreateTag}
          icon={LabelImportantIcon}
          options={{ label: 'Tags', menuParent: 'content' }}
        />

        <Resource
          name="cms/content/stylesheets"
          list={ListStylesheets}
          // edit={EditCommentQuestion}
          create={CreateStylesheet}
          icon={ColorLensIcon}
          options={{ label: 'Temas', menuParent: 'content' }}
        />

        <Resource
          name="cms/content/marks"
          list={ListMarks}
          // edit={EditCommentQuestion}
          create={CreateMark}
          icon={Crop75Icon}
          options={{ label: 'Marcadores', menuParent: 'content' }}
        />

        <Resource
          name="cms/content/linker"
          list={ListMarks}
          // edit={EditCommentQuestion}
          create={CreateStuffLinker}
          options={{ label: 'Vinculador', menuParent: 'content' }}
          icon={AddToPhotosIcon}
        />

        <Resource
          name="cms/grouper/popup"
          list={ListPopups}
          edit={EditPopup}
          create={CreatePopup}
          options={{ label: 'Popups', menuParent: 'content' }}
          icon={AddToPhotosIcon}
        />

        {/* Quizz submenu */}
        <Resource
          name="quizz"
          options={{ label: 'Checklist', isMenuParent: true }}
          icon={PlaylistAddCheck}
        />

        <Resource
          name="cms/grouper/quiz"
          list={ListQuizzes}
          // edit={EditQuizz}
          create={CreateQuiz}
          icon={PlaylistAddCheck}
          options={{ label: 'Quizzes', menuParent: 'quizz' }}
        />

        {/* Comments submenu */}
        <Resource
          name="comments"
          options={{ label: 'Comentários', isMenuParent: true }}
          icon={ModeCommentIcon}
        />

        <Resource
          name="cms/content/comments_titles"
          list={ListCommentQuestions}
          // edit={EditCommentQuestion}
          create={CreateCommentQuestion}
          icon={TitleIcon}
          options={{ label: 'Pergunta Título', menuParent: 'comments' }}
        />

        {/* Admin submenu */}
        <Resource
          name="admin"
          options={{ label: 'Administração', isMenuParent: true }}
          icon={VerifiedUserIcon}
        />
        <Resource
          name="cms/users"
          list={ListUsers}
          edit={EditUser}
          create={CreateUser}
          icon={PeopleIcon}
          options={{ label: 'Usuários', menuParent: 'admin' }}
        />

        <Resource
          name="cms/caches"
          list={CacheControl}
          icon={SdStorage}
          options={{ label: 'Cache', menuParent: 'admin' }}
        />

        <Resource
          name="cms/content/involved_people"
          list={ListPersons}
          // edit={EditPerson}
          create={CreatePerson}
          options={{ label: 'Pessoas', menuParent: 'content' }}
        />

        <Resource
          name="cms/content/tags"
          list={ListTags}
          // edit={EditTag}
          create={CreateTag}
          options={{ label: 'Tags', menuParent: 'content' }}
        />

        <Resource
          name="cms/content/stylesheets"
          list={ListStylesheets}
          // edit={EditCommentQuestion}
          create={CreateStylesheet}
          options={{ label: 'Temas', menuParent: 'content' }}
        />

        {/* Comments submenu */}
        <Resource
          name="comments"
          options={{ label: 'Comentários', isMenuParent: true }}
        />

        <Resource
          name="cms/content/comments_titles"
          list={ListCommentQuestions}
          // edit={EditCommentQuestion}
          create={CreateCommentQuestion}
          options={{ label: 'Pergunta Título', menuParent: 'comments' }}
        />
      </Admin>
    </ErrorBoundary>
  )
}

export default App
